import { useState } from "react";
import "./SinglePaymentSelection.css";
import SinglePaymentAccordionItem from "./SinglePaymentAccordionItem";
import { usePayment } from "../Checkout/context/PaymentContext";
import localeText from "../../../../locale";

const SinglePaymentSelection = ({ toast, combinePayment, totalPrice }) => {
  const { setSelectedPaymentMethod, isPaymentMethodAvailable } = usePayment();

  const payments = [
    { id: 1, title: localeText("payWithExtracreditAndWallet"), type: "creditCombined" },
    { id: 2, title: localeText("payWithBankTransfer"), type: "bankTransfer" },
    { id: 3, title: localeText("payWithCreditCard"), type: "creditCard" },
    { id: 4, title: localeText("payWithPayPal"), type: "paypal" },
  ];



  const [openItemId, setOpenItemId] = useState(null);

  const isPaymentDisabled = (id) => {
    if (!combinePayment) return false;

    const creditCardAvailable = isPaymentMethodAvailable("creditCard");
    const paypalAvailable = isPaymentMethodAvailable("paypal");

    switch (id) {
      case 1: // Extracredit + Wallet
        return !isPaymentMethodAvailable("extracredit") && !isPaymentMethodAvailable("wallet");
      case 2: // Bank Transfer
        return !isPaymentMethodAvailable("bankTransfer");
      case 3: // Credit Card
        return !creditCardAvailable;
      case 4: // PayPal
        return !paypalAvailable;
      default:
        return false;
    }
  };

  const toggleItem = (id, type) => {
    if (isPaymentDisabled(id)) return;

    if (openItemId === id) {
      setOpenItemId(null);
      setSelectedPaymentMethod(null);
    } else {
      setOpenItemId(id);
      setSelectedPaymentMethod(type);
    }
  };

  return (
    <div className="w-full mx-auto">
      {payments.map((payment) => (
        <SinglePaymentAccordionItem
          key={payment.id}
          title={payment.title}
          isOpen={openItemId === payment.id}
          onToggle={() => toggleItem(payment.id, payment.type)}
          id={payment.id}
          toast={toast}
          combinePayment={combinePayment}
          totalPrice={totalPrice}
          disabled={isPaymentDisabled(payment.id)}
        />
      ))}
    </div>
  );
};

export default SinglePaymentSelection;
